/*
 * @Date: 2021-03-01 15:59:00
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-08 17:11:31
 * @FilePath: \tmk\src\core\bootstrap.js
 */
/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2019-12-24 11:37:49
 * @LastAuthor: xiaoyao
 * @lastTime: 2020-12-07 17:25:46
 */
import Vue from 'vue'
import store from '@/store/'
import {
  //app
  ORG,
  DEFAULT_COLOR,
  DEFAULT_THEME,
  DEFAULT_LAYOUT_MODE,
  DEFAULT_COLOR_WEAK,
  SIDEBAR_TYPE,
  CURRENT_STEP,
  DEFAULT_FIXED_HEADER,
  DEFAULT_FIXED_HEADER_HIDDEN,
  DEFAULT_FIXED_SIDEMENU,
  DEFAULT_CONTENT_WIDTH_TYPE,
  DEFAULT_SHOW_TAB_MENU,
  //accounts
  CURRENT_CUST_INFO,
  //task
  IMPORT_TASK_ID,
  //call_list
  CALL_LIST_ID,
  CALL_LIST_NEXT_URL,
  CALL_LIST_PREV_URL,
  CALL_LIST_QUERY_PARAMS,
  DEFAULT_NOTICE_ID,
} from '@/store/mutation-types'
import config from '@/config/defaultSettings'
import { getCookie } from '@/utils/util.js'

export default function Initializer () {
  const c = config
  store.commit('SET_SIDEBAR_TYPE', Vue.ls.get(SIDEBAR_TYPE, true))
  store.commit('SET_CURRENT_STEP', Vue.ls.get(CURRENT_STEP, null))
  store.commit('TOGGLE_THEME', Vue.ls.get(DEFAULT_THEME, c.navTheme))
  store.commit('TOGGLE_LAYOUT_MODE', Vue.ls.get(DEFAULT_LAYOUT_MODE, c.layout))
  store.commit('TOGGLE_FIXED_HEADER', Vue.ls.get(DEFAULT_FIXED_HEADER, c.fixedHeader))
  store.commit('TOGGLE_FIXED_SIDERBAR', Vue.ls.get(DEFAULT_FIXED_SIDEMENU, c.fixSiderbar))
  store.commit('TOGGLE_CONTENT_WIDTH', Vue.ls.get(DEFAULT_CONTENT_WIDTH_TYPE, c.contentWidth))
  store.commit('TOGGLE_FIXED_HEADER_HIDDEN', Vue.ls.get(DEFAULT_FIXED_HEADER_HIDDEN, c.autoHideHeader))
  store.commit('TOGGLE_WEAK', Vue.ls.get(DEFAULT_COLOR_WEAK, c.colorWeak))
  store.commit('TOGGLE_COLOR', Vue.ls.get(DEFAULT_COLOR, c.primaryColor))
  store.commit('TOGGLE_SHOW_TAB_MENU', Vue.ls.get(DEFAULT_SHOW_TAB_MENU, c.showTabMenu))
  store.commit('SET_TOKEN', getCookie('token'))
  store.commit('SET_ORG', Vue.ls.get(ORG))

  //accounts
  store.commit('CURRENT_CUST_INFO', Vue.ls.get(CURRENT_CUST_INFO))


}



// WEBPACK FOOTER //
// ./src/core/bootstrap.js